import { makeOperator } from './Operator';
const isAnyValue = value => value != null;
export default makeOperator({
  name: 'EverEqual',
  values: [{
    name: 'value',
    isValid: isAnyValue
  }]
});